/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 *  ╔═○─┐ emotive
 *    ●●  ENGINE - Slide Right Gesture
 *  └─○═╝
 * ═══════════════════════════════════════════════════════════════════════════════════════
 *
 * Smooth glide to the right (2 beats)
 */

import { createSlideGesture } from './danceSteps.js';

export default createSlideGesture('right');
